interface CategoryMarkProps {
  name?: string;
  color?: string;
  size?: 'sm' | 'md';
}

export function CategoryMark({ name, color = '#675cff', size = 'md' }: CategoryMarkProps) {
  const initial = name?.trim().slice(0, 1) || '未';
  const sizeClass = size === 'sm' ? 'w-7 h-7 text-xs rounded-lg' : 'w-10 h-10 text-sm rounded-xl';

  return (
    <span
      className={`${sizeClass} inline-flex flex-shrink-0 items-center justify-center font-bold`}
      style={{ color, backgroundColor: `${color}18` }}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}
